import React from 'react';
import { inviteMessage, shareLinks, taggedLink } from '../utils/referrals';
import { phiTrack } from '../utils/phiTrack';

/**
 * Copy link, Copy invite message, native share sheet (where available), WhatsApp and Telegram.
 * Shared by the dashboard referral card and the navbar gift panel. Each action sends the /r/ link
 * with a short channel tag (?via=wa, ?via=ncopy from the navbar, …) so /admin/referrals can count
 * clicks, sign-ups, Mock 1 finishers and purchases per channel. `source` also tags analytics (mirrored as `placement`, since Phi drops `source`).
 */
export default function ReferralShareActions({ link, source, onNotice }) {
  const tag = (channel) => taggedLink(link, channel, source);
  const waLink = tag('whatsapp');
  const tgLink = tag('telegram');
  const share = { whatsapp: shareLinks(waLink, inviteMessage(waLink)).whatsapp, telegram: shareLinks(tgLink, inviteMessage(tgLink)).telegram };
  const track = (channel) => phiTrack('referral_share', source ? { channel, source, placement: source } : { channel });
  async function copyText(text, done, channel) {
    track(channel);
    try { await navigator.clipboard.writeText(text); onNotice(done); }
    catch { onNotice('Select and copy your link above.'); }
  }
  async function nativeShare() {
    track('native');
    const url = tag('native');
    try { await navigator.share({ title: 'CFA Mock Exam', text: inviteMessage(url).replace(` ${url}`, ''), url }); }
    catch { /* dismissed */ }
  }
  return <div className="referral-share">
    <button className="btn-ghost" type="button" onClick={() => copyText(tag('copy_link'), 'Link copied.', 'copy_link')}>Copy link</button>
    <button className="btn-ghost" type="button" onClick={() => copyText(inviteMessage(tag('copy_message')), 'Invite message copied. Paste it in your study group.', 'copy_message')}>Copy invite message</button>
    {typeof navigator !== 'undefined' && typeof navigator.share === 'function'
      ? <button className="btn-ghost" type="button" onClick={nativeShare}>Share…</button> : null}
    <a className="btn-ghost" href={share.whatsapp} target="_blank" rel="noopener noreferrer" onClick={() => track('whatsapp')}>WhatsApp</a>
    <a className="btn-ghost" href={share.telegram} target="_blank" rel="noopener noreferrer" onClick={() => track('telegram')}>Telegram</a>
  </div>;
}
